import { createMuiStyles } from '../../utils/mui';

export const footerStyles = createMuiStyles({
  footer: {
    bgcolor: 'grey.50',
    py: 4,
  },
  socialSection: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  socialIconContainer: {
    alignItems: 'center',
    maxWidth: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  socialIconButton: {
    mr: 4,
    p: 1,
  },
  socialIconLabel: {
    display: {
      xs: 'none',
      sm: 'inline-block',
    },
  },
  socialIconDivider: {
    ml: 2,
    mr: 4,
    my: 1,
    borderColor: 'grey.400',
    display: {
      xs: 'none',
      sm: 'inline-block',
    },
  },
  searchIcon: {
    color: 'common.black',
  },
  menuContainer: {
    mt: 2.5,
    mb: 4,
  },
  parentMenu: {
    mb: 2,
  },
  menu: {
    color: 'common.black',
    ':hover, :focus': {
      color: 'primary.dark',
    },
  },
  copyrightDivider: {
    mt: 4,
    mb: 2,
  },
  copyrightContent: {
    ':before': {
      content: '""',
      display: 'inline-block',
      height: '0.25rem',
      width: '0.25rem',
      bgcolor: 'grey.600',
      mr: 0.5,
      borderRadius: '50%',
      verticalAlign: 'super',
    },
  },
  gotoTopButton: {
    ml: 'auto',
    '.MuiButton-root': {
      py: 0.5,
      height: 'auto',
      textDecoration: 'underline',
    },
  },
});
